import React, { useEffect, useState } from "react";

export default function InstallPWAButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    setIsIOS(/iphone|ipad|ipod/.test(userAgent));

    // Listen for beforeinstallprompt (Android/Chrome)
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    try {
      await navigator.serviceWorker.ready;

      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log("User response:", outcome);

      setDeferredPrompt(null);
      setIsInstallable(false);
    } catch (err) {
      console.error("Install prompt failed:", err);
    }
  };

  if (isIOS) {
    return (
      <button
        className="p-2 bg-blue-500 text-white rounded"
        onClick={() =>
          alert(
            "On iPhone/iPad: Tap Share → Add to Home Screen to install this app."
          )
        }
      >
        Download App
      </button>
    );
  }

  return (
    <>
      {isInstallable && (
        <button
          className="p-2 bg-blue-500 text-white rounded"
          onClick={handleInstallClick}
        >
          Download App
        </button>
      )}
    </>
  );
}
